import React from 'react'

import { Collapse } from '@components/ui/CollapseElements'

import type { SimpleContentAccordionControlBaseProps } from './elements'
import { SimpleContentAccordionControl } from './elements'

interface SimpleContentAccordionProps extends SimpleContentAccordionControlBaseProps {
  children: NonNullable<React.ReactNode> | React.ReactNode[]
  visibleOnRender?: boolean
}

/**
 * Simple component with collapse functionality
 *
 * @param {SimpleContentAccordionProps} {
 *   children,
 *   className,
 *   title,
 *   titleTag = 'h2',
 *   visibleOnRender = true,
 * }
 */
export function SimpleContentAccordion({
  children,
  className,
  title,
  titleTag = 'h2',
  visibleOnRender = true,
}: SimpleContentAccordionProps) {
  const [isDetailVisible, setDetailVisible] = React.useState(visibleOnRender)

  function toggleVisibility() {
    setDetailVisible(state => !state)
  }

  return (
    <>
      <SimpleContentAccordionControl
        className={className}
        title={title}
        titleTag={titleTag}
        isDetailVisible={isDetailVisible}
        toggleVisibility={toggleVisibility}
      />
      <Collapse isExpanded={isDetailVisible}>{children}</Collapse>
    </>
  )
}
